import { fromVariables } from 'convert-to-jcamp';
export function toJcamps(analysis, options = {}) {
    const jcamps = [];
    for (const spectrum of analysis.spectra) {
        jcamps.push(getJcamp(spectrum, options));
    }
    return jcamps;
}
function getJcamp(spectrum, options) {
    const { info = {}, meta = {} } = options;
    const jcampOptions = {
        options: {},
        info: {
            title: spectrum.title,
            dataType: spectrum.dataType,
            ...info,
        },
        meta: { ...spectrum.meta, ...meta },
    };
    return fromVariables(spectrum.variables, jcampOptions);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9KY2FtcHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdG8vdG9KY2FtcHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBU2pELE1BQU0sVUFBVSxRQUFRLENBQUMsUUFBa0IsRUFBRSxVQUEyQixFQUFFO0lBQ3hFLE1BQU0sTUFBTSxHQUFHLEVBQUUsQ0FBQztJQUNsQixLQUFLLE1BQU0sUUFBUSxJQUFJLFFBQVEsQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUN4QyxNQUFNLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUMzQyxDQUFDO0lBQ0QsT0FBTyxNQUFNLENBQUM7QUFDaEIsQ0FBQztBQUVELFNBQVMsUUFBUSxDQUFDLFFBQWtCLEVBQUUsT0FBd0I7SUFDNUQsTUFBTSxFQUFFLElBQUksR0FBRyxFQUFFLEVBQUUsSUFBSSxHQUFHLEVBQUUsRUFBRSxHQUFHLE9BQU8sQ0FBQztJQUV6QyxNQUFNLFlBQVksR0FBRztRQUNuQixPQUFPLEVBQUUsRUFBRTtRQUNYLElBQUksRUFBRTtZQUNKLEtBQUssRUFBRSxRQUFRLENBQUMsS0FBSztZQUNyQixRQUFRLEVBQUUsUUFBUSxDQUFDLFFBQVE7WUFDM0IsR0FBRyxJQUFJO1NBQ1I7UUFDRCxJQUFJLEVBQUUsRUFBRSxHQUFHLFFBQVEsQ0FBQyxJQUFJLEVBQUUsR0FBRyxJQUFJLEVBQUU7S0FDcEMsQ0FBQztJQUVGLE9BQU8sYUFBYSxDQUFDLFFBQVEsQ0FBQyxTQUFTLEVBQUUsWUFBWSxDQUFDLENBQUM7QUFDekQsQ0FBQyJ9